/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Card, CardContent } from "@material-ui/core";
import ConfirmCancel from "../../../components/DialogComponent/ConfirmCancel";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import CreateTaskItem from "./CreateTaskItem";
import { getStandardTasksList } from "../../../services/apiservices/tasks";
import { EventEmitter } from "../../../services/event.service";
import { useParams } from "react-router";
import { getServicesDetails } from "../../../services/apiservices/settings";
import AuthContext from "../../../hooks/authContext";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import styles from "../clients.module.scss";
import { useMediaQuery } from "@mui/material";
const stepId = 4;
function Step(props) {
  const {SummaryList, setSummaryList, customTaskList, setCustomTaskList, taskList, settaskList, stepError, setStepError, setUpdateMessage, updateMessage, settingsData} = props;
  const createTaskRoot = useRef(null);
  const auth = useContext(AuthContext);
  // const [stepError, setStepError] = useState({});
  // const [taskList, settaskList] = useState([]);
  const [taskFrequencies, setTaskFrequencies] = useState([]);
  // const [customTaskList, setCustomTaskList] = useState([]);
  // const [SummaryList, setSummaryList] = useState([]);
  const { clientId } = useParams();
  const [forceTaskRefresh, setForceTaskRefresh] = useState(null);
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const isMobile = useMediaQuery("(max-width:767px)");
  const {
    currentStep,
    goToStep,
    onCancelAll,
    stepContentValues,
    loading,
    classes,
  } = props;

  const fetchsettaskList = () => {
    setTaskFrequencies([
      "Daily",
      "Weekends",
      "Weekly",
      "Bi-Weekly",
      "Monthly",
      "Quarterly",
      "Semi-Annual",
      "Annually",
    ]);
    let combinedTasks = [];
    getStandardTasksList({}, (standardTasksRes) => {
      if (standardTasksRes) {
        combinedTasks.push(...standardTasksRes);
      }

      getServicesDetails(companyId, (servicesDetailsRes) => {
          if (servicesDetailsRes?.data) {
          const subDetails = servicesDetailsRes?.data?.filter(items => servicesDetailsRes?.data.some(item => item.id === items.parentCategoryId))?.filter(item => item.deleted !== true);
            combinedTasks.push(...subDetails);
          }

          settaskList(combinedTasks);
      }, (error) => {
          console.error("Error fetching services details:", error);
          settaskList(combinedTasks);
    });
    },
    )
  };
  const scrolltoFrequency = () => {
    createTaskRoot !== null &&
      createTaskRoot?.current &&
      createTaskRoot.current.scrollIntoView({
        block: "start",
        inline: "start",
        behavior: "smooth",
      });
  };

  useEffect(() => {
    fetchsettaskList();
    EventEmitter.subscribe("scrolltoCreateTaskItemTop", scrolltoFrequency);
    return () => {
      EventEmitter.unsubscribe("scrolltoCreateTaskItemTop", scrolltoFrequency);
    };
  }, []);

  const setEditData = (editData) => {
    let summaryDataEdit = [];
    if (editData?.shiftData) {

      [...Object.keys(editData?.shiftData)].map((shiftId) => {
        let inShiftData = editData?.shiftData[shiftId];
        let inShiftTasksKeys = Object.keys(inShiftData);
        if (inShiftTasksKeys?.length > 0) {
          inShiftTasksKeys.map((taskItemId) => {
            let taskItem = inShiftData[taskItemId];
            let shiftAllData = props?.stepContentValues?.shiftsList?.filter(
              (allsitem) => allsitem?.shiftId === shiftId
            );
            shiftAllData =
              shiftAllData?.length > 0
                ? shiftAllData[0]
                : { shiftId: shiftId, title: taskItem?.title };
            summaryDataEdit.push({
              id: taskItemId,
              frequency: taskItem?.frequency,
              tasks: taskItem?.tasksList,
              shift: shiftAllData,
              // taskFrequency: taskItem?.taskFrequency || 0,
            });
            return taskItem;
          });
        }
        return shiftId;
      });
    } else if(editData?.SummaryList){
      [...Object.keys(editData?.SummaryList)]?.map((shiftId) => {
        let inShiftData = editData?.SummaryList[shiftId];
        if (inShiftData?.tasks?.length > 0) {
            summaryDataEdit.push({
              id: inShiftData?.id,
              frequency: inShiftData?.frequency,
              tasks: inShiftData?.tasks,
              shift: inShiftData?.shift,
              // taskFrequency: inShiftData?.taskFrequency || 0,
            });
            return inShiftData;
          };
        return shiftId;
        })
      };
    let customTasksList = [];
    if (editData?.customTaskList) {
      customTasksList = [
        ...Object.entries(editData?.customTaskList)?.map(([key, value]) => {
          return {
            taskId: key,
            custom: true,
            ...value,
          };
        }),
      ];
    }
    setCustomTaskList(customTasksList);
    setSummaryList(summaryDataEdit);
  };

  useEffect(() => {
    if (props?.editData !== false) {
      setEditData(props?.editData);
    }
  }, [props?.editData, props?.stepContentValues?.shiftsList]);

  useEffect(() => {
    if (props?.displayStep == 4 && stepContentValues && props?.editData === false) {
      setEditData(stepContentValues);
    }
  }, [props?.displayStep]);

  const addSummaryListItem = (taskItem) => {
    setSummaryList([...SummaryList, taskItem]);
  };
  const updateSummaryListItem = (id, taskItem) => {
    setSummaryList([
      ...SummaryList?.map((item) => (item.id === id ? taskItem : item)),
    ]);
  };

  const removeSummaryListItem = (taskItem) => {
    const idToRemove =
      typeof taskItem === 'string'
        ? taskItem
        : taskItem?.taskId || taskItem?.id;
  
    setSummaryList((prev) =>
      prev
        .map((summary) => {
          if (Array.isArray(summary.tasks)) {
            const updatedTasks = summary?.tasks?.filter(
              (task) => task?.taskId !== idToRemove
            );
            return { ...summary, tasks: updatedTasks };
          }
          return summary;
        })
        ?.filter((summary) => summary.tasks.length > 0)
    );
  
    setCustomTaskList((prev) =>
      prev?.filter((task) => task?.taskId !== idToRemove && task?.id !== idToRemove)
    );
  
    setForceTaskRefresh(idToRemove);
  };

  const getTaskTitle = (task) => {
    let allTasks = [...taskList, ...customTaskList];
    let selectedTasks = allTasks.filter((sitem) =>
      task === (sitem?.taskId ?? sitem?.id)
    );
    selectedTasks = selectedTasks[0];
    return selectedTasks?.title;
  };

  const validateAndGoNext = () => {
    let errormessages = stepError;
    let isValid = true;
    if (
      typeof SummaryList === "undefined" ||
      SummaryList === "" ||
      SummaryList?.length <= 0
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        SummaryList: "Must Create at least one Task Group",
      };
    } else {
      errormessages = { ...errormessages, SummaryList: "" };
    }

    setStepError(errormessages);
    if (isValid) {
      let SummaryListNew = SummaryList?.map((sitem) => {
        let tasksList = sitem?.tasks?.map((stitem) => {
          return { taskId: stitem, title: getTaskTitle(stitem) };
        });
        return { ...sitem, tasksList };
      });
      let customTasksListmap = {};
      customTaskList?.map((ctasklistitem) => {
        customTasksListmap[ctasklistitem.taskId] = {
          title: ctasklistitem?.title,
          description: ctasklistitem?.description,
          frequency: ctasklistitem?.frequency,
          shift: ctasklistitem?.shift,
          interval: ctasklistitem?.interval,
          startDate: ctasklistitem?.startDate || '',
          endDate: ctasklistitem?.endDate || '',
          // pos: ctasklistitem?.pos || false,
          // posFrequency: ctasklistitem?.posFrequency || 0
        };
        return ctasklistitem;
      });
      setUpdateMessage(false);
      props?.validateAndGoNext &&
        props?.validateAndGoNext(
          { customTaskList: customTasksListmap, SummaryList: SummaryListNew },
          { step4: true }
        );
    }
  };
  
  const allTasks = [...taskList];
  return (
    <>
      {!clientId && (
          <div
            style={{
              backgroundColor: "#FFF8E5",
              border: "1px solid #F1C40F",
              borderRadius: "8px",
              padding: "10px 14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "16px",
              marginBottom: "8px",
              fontSize: "14px",
              color: "#A75E00",
              fontWeight: 500,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <span>
              This client is incomplete and has been set to <strong>Inactive</strong> until all details are completed and saved.
            </span>
          </div>
      )}
      
      {updateMessage === true && (
        <div
          style={{
            backgroundColor: "#FFF8E5",
            border: "1px solid #F1C40F",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "16px",
            fontSize: "14px",
            color: "#A75E00",
            fontWeight: 500,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>
            You must click the <strong>Update</strong> button below to save your data.
          </span>
        </div>
      )}

      {props?.stepContentValues?.shiftsList?.length === 0 || !props?.stepContentValues?.shiftsList ? (
        <Card className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
          <CardContent className="pt-24 text-center" style={{ paddingBottom: "48px" }}>
            <CalendarMonthOutlinedIcon style={{ color: "#9ca3af", width: "40px", height: "40px", margin: "0 auto" }} />
            <h3 className="mt-16 text-[#020817] dark:text-white"  style={{ fontSize: "16px", fontWeight: "500" }}>No shifts added</h3>
            <p className="mt-8" style={{ fontSize: "14px", fontWeight: "500", color: "#6b7280" }}>
              You need to create shifts before you can assign tasks.
            </p>
            <div className="mt-24">
              <Button variant="contained" className="bg-green color-white" onClick={() => {props?.setDisplayStep(3)}}>
                Go to Shifts
              </Button>
            </div>
          </CardContent>
        </Card>
      ) : (
        <>
          {props?.stepContentValues?.shiftsList?.map((shift) => (
            <CreateTaskItem
              shift={shift}
              taskList={allTasks}
              standardTasks={taskList ? taskList : []}
              customtaskList={customTaskList ? customTaskList : []}
              setCustomTask={setCustomTaskList}
              taskFrequencies={taskFrequencies}
              SummaryList={SummaryList}
              addSummaryListItem={addSummaryListItem}
              updateSummaryListItem={updateSummaryListItem}
              removeSummaryListItem={removeSummaryListItem}
              forceTaskRefresh={forceTaskRefresh}
              editData={props?.editData}
              stepError={stepError}
              setUpdateMessage={setUpdateMessage}
              setStandardTasks={settaskList}
              settingsData={settingsData}
            />
          ))}
        </>
      )}

      {updateMessage === true && (
        <div
          style={{
            backgroundColor: "#FFF8E5",
            border: "1px solid #F1C40F",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "16px",
            fontSize: "14px",
            color: "#A75E00",
            fontWeight: 500,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>
            You must click the <strong>Update</strong> button below to save your data.
          </span>
        </div>
      )}

      {/* Content Ends */}
      <div className="buttonsWrap d-flex flex-center flex-space-between mv-20">
        <DialogComponent
          buttonWrapClassName="d-inline"
          buttonClassName="bg-white dark:bg-gray-800"
          buttonProps={{
          variant: "outline",
          disabled: loading,
          }}
          buttonLabel={"Cancel"}
          ModalTitle={"Are you sure you want to cancel this entry?"}
          ModalContent={<ConfirmCancel onCancelAll={onCancelAll} message={"Any unsaved data will be deleted."} />}
        />
        <Button
          type="button"
          color={"primary"}
          variant={"contained"}
          className={isMobile  ? "ml-15 bg-green color-white" : "w-full sm:w-auto mr-15 bg-green color-white"}
          onClick={() => validateAndGoNext()}
          disabled={loading === true ? true : false}
        >
          {loading === true
            ? "Loading..."
            : props?.editData !== false
            ? "Update"
            : "Submit"}
        </Button>
      </div>
    </>
  );
}
export default Step;
